import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { subscribeWithSelector } from "zustand/middleware";
import { createRunSlice, type RunSlice } from "./run.slice";
import { createMetricsSlice, type MetricsSlice } from "./metrics.slice";
import { createFramesSlice, type FramesSlice } from "./frames.slice";
import { createBreakpointsSlice, type BreakpointsSlice } from "./breakpoints.slice";
import { createErrorsSlice, type ErrorsSlice } from "./errors.slice";
import { createOutputsSlice, type OutputsSlice } from "./outputs.slice";

export interface RunControlState
  extends RunSlice,
    MetricsSlice,
    FramesSlice,
    BreakpointsSlice,
    ErrorsSlice,
    OutputsSlice {}

export const useRunControlStore = create<RunControlState>()(
  subscribeWithSelector(
    immer((...args) => ({
      ...createRunSlice(...args),
      ...createMetricsSlice(...args),
      ...createFramesSlice(...args),
      ...createBreakpointsSlice(...args),
      ...createErrorsSlice(...args),
      ...createOutputsSlice(...args),
    }))
  )
);
